import { faCompress, faExpand, faMagicWandSparkles, faPlus, faXmark } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AiTopBarActionButton = ({ icon, onClick, title }) => (
    <button
        type='button'
        onClick={onClick}
        title={title}
        className='group flex size-[30px] cursor-pointer items-center justify-center rounded-[9px] border border-slate-400/35 bg-slate-950/70 text-[13px] text-slate-50 transition-colors hover:bg-slate-900'
    >
        <FontAwesomeIcon
            icon={icon}
            className='transition-transform duration-100 ease-out group-hover:scale-120'
        />
    </button>
);

export const AiTopBar = ({ t, companyName, isFullscreen, onNewChat, onToggleFullscreen, onClose }) => {
    const actions = [
        {
            id: 'fullscreen',
            icon: isFullscreen ? faCompress : faExpand,
            onClick: onToggleFullscreen,
            title: isFullscreen ? t('Compact view') : t('Fullscreen'),
        },
        {
            id: 'new-chat',
            icon: faPlus,
            onClick: onNewChat,
            title: t('New chat'),
        },
        {
            id: 'close',
            icon: faXmark,
            onClick: onClose,
            title: t('Close'),
        },
    ];

    return (
        <div className='h-[64px] shrink-0 border-b border-slate-600/30 bg-[linear-gradient(135deg,rgba(8,11,20,1)_0%,rgba(10,14,24,1)_46%,rgba(13,18,31,1)_100%)] px-4 py-2.5 text-slate-50 shadow-[inset_0_-12px_24px_rgba(132,204,22,0.12)]'>
            <div className='flex items-center justify-between'>
                <div className='flex items-center gap-3'>
                    <div className='flex size-[30px] items-center justify-center rounded-full border border-lime-400 bg-[radial-gradient(circle_at_45%_30%,#1b2a0d,#10180a_55%,#0a0f08_100%)] shadow-[0_0_0_3px_rgba(132,204,22,0.2),0_8px_18px_rgba(0,0,0,0.35)]'>
                        <FontAwesomeIcon
                            icon={faMagicWandSparkles}
                            className='text-sm text-lime-400'
                        />
                    </div>
                    <div className='flex flex-col gap-0.5'>
                        <h2 className='m-0 text-[15px] font-bold leading-tight'>{t('AI Insights')}</h2>
                        <p className='m-0 text-xs leading-tight text-slate-400'>{companyName}</p>
                    </div>
                </div>
                <div className='flex items-center gap-2'>
                    {actions.map((action) => (
                        <AiTopBarActionButton
                            key={action.id}
                            icon={action.icon}
                            onClick={action.onClick}
                            title={action.title}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};
